import React from 'react';
import { Link } from 'react-router-dom';
import {
  Box,
  Container,
  Grid,
  Typography,
  Button,
  Stack,
  Divider,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

const footerSections = [
  {
    title: 'About BookMyOP',
    links: ['About Us', 'Careers', 'Press', 'Blog']
  },
  {
    title: 'For Patients',
    links: ['Search for Doctors', 'Specialties', 'Lab Tests', 'Health Packages']
  },
  {
    title: 'For Doctors',
    links: ['Register as Doctor', 'Doctor Login', 'Doctor App', 'Doctor FAQ']
  },
  {
    title: 'Support',
    links: ['Help Center', 'Contact Us', 'Privacy Policy', 'Terms & Conditions']
  }
];

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (isMobile) {
    return null;
  }

  return (
    <Box sx={{ bgcolor: theme.palette.primary.dark, color: 'white', py: 6 }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {footerSections.map((section) => (
            <Grid item xs={12} sm={6} md={3} key={section.title}>
              <Typography variant="h6" gutterBottom>
                {section.title}
              </Typography>
              <Stack spacing={1}>
                {section.links.map((link) => (
                  <Button 
                    key={link}
                    component={Link}
                    to={`/${link.toLowerCase().replace(/\s+/g, '-')}`}
                    color="inherit"
                    sx={{ 
                      justifyContent: 'flex-start',
                      color: 'rgba(255,255,255,0.8)',
                      '&:hover': {
                        color: 'white'
                      }
                    }}
                  >
                    {link}
                  </Button>
                ))}
              </Stack>
            </Grid>
          ))}
        </Grid>
        <Divider sx={{ my: 4, bgcolor: 'rgba(255,255,255,0.1)' }} />
        <Typography textAlign="center" sx={{ color: 'rgba(255,255,255,0.8)' }}>
          © {new Date().getFullYear()} BookMyOP. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer; 